<div class="row">
  <div class="col-12">
    <h4 class="mt-0 text-center text-md-left" translate>OFFER</h4>
    <hr>
  </div>
  <div class="col-12">
    <lib-gung-settings-fortnox-offer-confirmation></lib-gung-settings-fortnox-offer-confirmation>
  </div>
  <div class="col-12">
    <lib-offer-configuration></lib-offer-configuration>
  </div>
  <div class="col-12 mt-3" *ngIf="offerConfig">
    <div class="d-flex justify-content-between align-items-baseline">
      <h5 class="mb-0 mt-0" translate>OFFER_DB_CONFIG</h5>
      <button class="btn btn-default" style="font-size: 20px;" (click)="saveOfferConfig()">
        <i ngbTooltip="{{'SAVE' | translate}}" class="fas fa-save"></i>
      </button>
    </div>
    <hr>
    <div class="row">
      <div class="col-12 col-md-6">
        <lib-gung-text-input
          gungTranslate="OFFER_PDF_ATTACHMENT_NAME"
          [(ngModel)]="offerConfig.offerPdfAttachmentName"
          [placeholder]="'Offert - {offerId}'"
        ></lib-gung-text-input>
      </div>
      <div class="col-12 mt-2">
        <lib-gung-html-editor
          gungTranslate="OFFER_BODY"
          [(ngModel)]="offerConfig.offerBody"
        ></lib-gung-html-editor>
      </div>
      <div class="col-12 mt-2">
        <lib-gung-html-editor
          gungTranslate="OFFER_MAIL_SIGNATURE"
          [(ngModel)]="offerConfig.offerMailSignature"
        ></lib-gung-html-editor>
      </div>
    </div>
  </div>
</div>
